import {Component, ViewChild} from "@angular/core";
import { GoogleMap, MapInfoWindow } from "@angular/google-maps";

import { LatLngModel } from "../../../../../shared-library/models/geolocation/lat-lng.model";

import { DirectoryItemModel } from "../../models/directory-item.model";
import { MapMarkerModel } from "./map-marker.model";

@Component({
    selector: "pcg-ng-google-map",
    template: require('./google-map.component.html')
})
export class GoogleMapComponent {
    @ViewChild("mapElement", { static: false })
    public mapComponentRef: GoogleMap;

    public location: google.maps.LatLngLiteral = {
        lat: 53.629,
        lng: -1.823
    };

    public options: google.maps.MapOptions = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDoubleClickZoom: true,
        scrollwheel: false,
        zoomControl: true,
        maxZoom: 18
    };

    public zoom = 12;

    public markers: Array<MapMarkerModel> = [];

    @ViewChild(MapInfoWindow, { static: false })
    public infoWindowRef: MapInfoWindow;
    public infoWindowContent: string;

    private _isMapInitialized: boolean = false;

    public initializeMap(): void {
        if (this._isMapInitialized) {
            return;
        }

        navigator.geolocation.getCurrentPosition(position => {
            this.location = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
        }, error => {
            console.warn(error.message);
        });

        this._isMapInitialized = true;
    }

    public setMapCenter(lat: number, lng: number): void {
        this.location = {
            lat: lat,
            lng: lng
        };
    }

    public updateMapMarkers(pageItems: Array<DirectoryItemModel>): void {
        if (!this._isMapInitialized) {
            this.initializeMap();
        }

        this.markers = [];
        const bounds = new google.maps.LatLngBounds();
        bounds.extend(this.location);

        pageItems.forEach((model: DirectoryItemModel) => {
            if (model.hasValidGeoLocation) {
                const position = new google.maps.LatLng(model.latitude, model.longitude);
                bounds.extend(position);

                const infoWindowContent = "<div class='pcg-google-map-info-window'>"
                    + `<span class='pcg-google-map-info-window__title'>${model.name}</span>`
                    + (model.hasValidAddress ? `<br/><span>${model.address}</span>` : "")
                    + (model.hasValidPostcode ? `<br/><span>${model.postcode}</span>` : "")
                    + (model.hasValidPhoneNumber ? `<br/><span><b>Phone:</b> ${model.phone}</span>` : "")
                    + (model.hasValidEmailAddress ? `<br/><span><b>Email:</b> ${model.email}</span>` : "")
                    + (model.hasValidWebsiteAddress ? `<br/><span><a href="${model.website}" target="_blank">${model.website}</a></span>` : "")
                    + "</div>";

                this.markers.push({
                    position: position,
                    label: null,
                    title: model.name,
                    info: infoWindowContent,
                    options: {
                        animation: google.maps.Animation.DROP,
                        draggable: false
                    }
                });
            }
        });

        this.mapComponentRef.fitBounds(bounds, 50);
    }

    public onMapMarkerClicked(position: LatLngModel, content: string): void {
        this.infoWindowContent = content;
        this.infoWindowRef.position = position;
        this.infoWindowRef.open();
    }
}
